import VimeoContainer from '@u-wave/react-vimeo'
import YoutubeContainer from '@u-wave/react-youtube'
import { store } from 'app_storage/redux-storage'
import React from 'react'

type ITypePlatformVideo = 'youtube' | 'vimeo'

interface IOptionsVideo {
  controls?: boolean
  paused?: boolean
  onReady?: any
  onPause?: any
  onPlay?: any
  onEnd?: any
  width?: number | string
  height?: number | string
  autopause?: boolean
  autoplay?: boolean
  className?: string
}

class VideoService {

  private storeObject = store

  constructor() {
  }

  /**
   * @INFO Renderizar un video según la plataforma
   * @param _type
   * @param _url
   * @param _options
   * @returns
   */
  public renderByPlatform = (_type: ITypePlatformVideo, _url: string, _options?: IOptionsVideo) => {

    if(!_type || !_url) return null
    let url = _url
    // @INFO Obtener el id del video
    if(_url.includes('https://') && _type === 'youtube'){
      const aux = url.split('?')[1]
      if(aux){
        let idVideo = aux.match(/v=(.)+/gi)
        if(idVideo && idVideo[0]){
          url = idVideo[0].replace('v=', '').replace('&', '')
        }
      }
    } else if (_url.includes('https://') && _type === 'vimeo') {
      const aux = _url.split('/')
      if(aux && aux.length){
        _url = aux[aux.length - 1]
      }
    }

    switch (_type) {
      case 'youtube':
        return (
            <YoutubeContainer
              video={url}
              controls={_options?.controls}
              paused={_options?.paused}
              onReady={_options?.onReady}
              onPause={_options?.onPause}
              onEnd={_options?.onEnd}
              onPlaying={_options?.onPlay}
              width={_options?.width}
              height={_options?.height}
              className={_options?.className}
              autoplay={_options?.autoplay}
            />
        )
      case 'vimeo':
        return (
            <VimeoContainer
              video={url}
              controls={_options?.controls}
              paused={_options?.paused}
              autopause={_options?.autopause}
              onReady={_options?.onReady}
              onPause={_options?.onPause}
              onPlay={_options?.onPlay}
              onEnd={_options?.onEnd}
              width={_options?.width}
              height={_options?.height}
              className={_options?.className}
              autoplay={_options?.autoplay}
            />
        )
      default:
        return null
    }
  }


}

export default VideoService
